<template>
  <div class="register-client">
    <form class="client-form">
      <div class="form__title">
        Контроль отсройки
      </div>
      <div class="form__title"></div>

      <label class="search-label">
        <input
          type="text"
          name="company"
          autocomplete="off"
          placeholder="Клиент"
          v-model.trim="company"
          @input="findClient"
          :class="{ error: $v.company.$dirty && !$v.company.required }"
        />
        <div class="search-result">
          <p
            v-for="(result, index) in searchResult"
            @click="filInfo(index)"
            :key="index"
          >
            {{ result.title }}
          </p>
        </div>
      </label>
      <label class="error" v-if="$v.company.$dirty && !$v.company.required"
        >Поле 'Клиент' не должно быть пустым</label
      >

      <div class="my-select-wrapper" ref="mySelect">
        <p class="my-select" @click="showSelectMenu()">{{collection.name}}</p>
        <div class="my-select__submenu" ref="submenu">
          <p 
            v-for="(collectionItem, index) in collectionsList"
            :key="index"
            @click="changeCollection($event, index)"
            :data-id="collectionItem.id"
            >{{collectionItem.name}}</p>
        </div>
        <span class="error-text">Необходимо выбрать коллекцию</span>
      </div>

      <input
        type="date"
        name="controlDate"
        class="controlDate"
        placeholder="Дата отстройки дд.мм.гггг"
        v-model.trim="controlDate"
        :class="{ error: $v.controlDate.$dirty && !$v.controlDate.required }"
       
      />
      <label
        class="error"
        v-if="$v.controlDate.$dirty && !$v.controlDate.required"
        >Поле 'Дата' не должно быть пустым</label
      >

      <input
        type="submit"
        value="Сформировать"
        id="registerClient"
        v-on:click.prevent="sendForm()"  
      />
    </form>
  </div>
</template>
<script>
import { required } from "vuelidate/lib/validators"; //валидатор

export default {
  data: () => ({
    company: "",
    companyId: "",
    collection: {
      name: "Выбрать коллекцию",
      id: ''
    },
    controlDate: "",
    searchResult: [],
    collectionsList: []
  }),
  validations: {
    company: { required },
    collection: { required },
    controlDate: { required }
  },
  methods: {
    findClient(e) {
      let that = this;
      if (e.target.value.length >= 4) {
        this.$store
          .dispatch("COMPANY_SEARCH", this.company)
          .then((response) => {
            that.searchResult = response.data.data;
          });
      } else {
        that.searchResult = [];
      }
    },
    filInfo(index) {
      let choice = this.searchResult[index];
      this.company = choice.title;
      this.companyId = choice.id;
      this.searchResult = [];
    },
    sendForm() {

      if (this.$v.$invalid) {
        this.$v.$touch();
        if(this.collection.id == ''){
          this.$refs.mySelect.classList.add('error')
        }
        return;
      }
      else if(this.collection.id == ''){
        this.$refs.mySelect.classList.add('error')
        return
      }else {
          let data = {
            companyId: this.companyId,
            collectionId: this.collection.id,
            datePresentation: this.controlDate
          }
          this.$store.dispatch('CREATE_CONTROL', data).then(response => {
            console.log('response', response)
            if(response.data.status != "success"){
              this.$makeToast(
                "Упс!",
                "danger",
                "Почему-то сервр не захотел сохранять отчет, возможно клиент выбран не из выпадающего списка:(",
                5000);
            } else {
              this.$localStorageSet('currentControlID', response.data.data.id)
              this.$localStorageSet('currentClient', this.companyId)
              this.$localStorageSet('miniCart', {baskets: []})
              this.$router.push('/control-catalog/')
            }
          })
      }

      
    },
    changeCollection(e, index){
      this.collection.name = e.target.textContent
      this.collection.id = e.target.dataset.id
      this.hideSelectMenu();
    },
    hideSelectMenu(){
      let submenu = this.$refs.submenu;
      submenu.classList.remove('show')
      this.$refs.mySelect.classList.remove('error')
    },
    showSelectMenu(){
      let submenu = this.$refs.submenu;
      submenu.classList.add('show')
    },
    startComponent(){
      this.$localStorageDelete('currentControlID')  //Удалить ID отчета, если есть
      this.$store.dispatch('GET_CONTROL_COLLECTION_LIST').then(resp => {
        console.log('resp', resp)
        this.collectionsList = resp.data.data;
      })
    }
  },
  created() {
    this.startComponent();
  },
};
</script>
<style lang="scss" scoped>
.presentationDate::-webkit-inner-spin-button {
  display: none;
}
.client-form {
  justify-content: flex-start;
  padding-top: 50px;
}
input:not(#registerClient) {
  padding-left: 10px;
}
input[type="date"]::-webkit-calendar-picker-indicator {
  background: url("https://cdn3.iconfinder.com/data/icons/linecons-free-vector-icons-pack/32/calendar-16.png")
    center 80% no-repeat;
  color: rgba(0, 0, 0, 0);
  opacity: 1;
}
input[type="submit"] {
  position: fixed;
  bottom: 0;
  margin-bottom: 0;
  width: 100%;
  left: 0;
}
.search-label {
  margin: 0;
  position: relative;
}
.search-result {
  width: 100%;
  background: #fff;
  position: absolute;
  top: 50%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  max-height: 400px;
  overflow-y: auto;
  z-index: 3;
  p {
    padding: 10px;
    font-size: 14px;
  }
}
.error-text{
  display: none;
  text-align: center;
  width: 100%;
  align-items: center;
  justify-content: center;
  position: absolute;
  color: #ff0000;
  font-weight: normal;
  margin-top: -26px;
  font-size: 12px;
}
.my-select-wrapper{
  position: relative;
  &.error{
    .my-select{
      border: 1px solid red;
    }
    .error-text{
      display: flex;
    }
  }
}
.my-select{
  width: 250px;
  margin-bottom: 38px;
  height: 20px;
  background: none;
  border: none;
  border-bottom: 1px solid #fff;
  padding: 5px 0px;
  color: #fff;
  font-size: 12px;
  line-height: 16px;
  outline: none;
  height: 40px;
  min-height: 40px;
  display: flex;
  align-items: center;
  padding-left: 10px;
  
}
.my-select__submenu{
  position: absolute;
  width: 100%;
  top: 40px;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  max-height: 200px;
  display: none;
  z-index: 2;
  &.show{
    display: flex;
  }

  p{
    color: #000;
    background: #fff;
    min-height: 40px;
    display: flex;
    align-items: center;
    padding-left: 10px;
    border-bottom: 1px solid #dcdcdc;
    font-size: 12px;

  }
}


</style>